// extracted by mini-css-extract-plugin
export default {"wrapper":"breakdown-donut-chart_wrapper__sKqA-"};